import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAWPDocumentTypes(orderFormTypeId) {
  const response = await $.soap({
    body: {
      GetAWPDocumentTypes: {
        $xmlns: 'http://dla.mil/ems/bpm/document',
        FormTypeID: orderFormTypeId
      }
    },
    blueprintArrays: ['GetAWPDocumentTypesResponse.LU_DocumentObjectMapping'],
    blueprint: {
      documentTypes: [
        '$..LU_DocumentObjectMapping',
        {
          objectCode: '$..ObjectCode',
          objectDescription: '$..ObjectDescription',
          orderFormTypeId: '$..OrderFormTypeID',
          orderFormTypeCode: '$..OrderFormTypeCode',
          orderFormTypeName: '$..OrderFormTypeName',
          isRequired: '$..IsRequired',
          documentTypeDescription: '$..DocumentTypeDescription',
          documentTypeId: '$..DocumentTypeID',
          documentTypeCode: '$..DocumentTypeCode',
          defaultFileName: '$..DefaultFileName',
          attachmentId: '$..GUID'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.documentTypes;
}
